// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg: #0f172a;
    --panel: #0b1220;
    --text: #e5e7eb;
    --muted: #94a3b8;
    --brand: #6366f1;
    --brand-600: #4f46e5;
    --border: #1f2937;
    --shadow: rgba(2, 6, 23, 0.6);
}

* {
    box-sizing: border-box;
}

body {
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
    margin: 0;
    padding: 0;
    background-color: var(--bg);
    color: var(--text);
    line-height: 1.6;
}

.site-header {
    background: linear-gradient(180deg, rgba(99,102,241,0.12), rgba(99,102,241,0) 60%);
    border-bottom: 1px solid var(--border);
    position: sticky;
    top: 0;
    z-index: 10;
    backdrop-filter: blur(6px);
}

.header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
}

.brand {
    font-weight: 700;
    letter-spacing: 0.2px;
}

nav .nav {
    list-style: none;
    display: flex;
    gap: 16px;
    margin: 0;
    padding: 0;
}

nav .nav a {
    color: var(--text);
    text-decoration: none;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid transparent;
    transition: all 160ms ease;
}

nav .nav a:hover {
    background: rgba(99, 102, 241, 0.12);
    border-color: rgba(99, 102, 241, 0.25);
}

nav .nav a.active {
    background: rgba(99, 102, 241, 0.2);
    border-color: rgba(99, 102, 241, 0.35);
    color: #fff;
}

.container {
    max-width: 1024px;
    width: 100%;
    margin: 0 auto;
    padding: 24px 20px 40px;
}

.home {
    background: radial-gradient(1200px 600px at 50% -20%, rgba(99, 102, 241, 0.18), transparent 50%), var(--panel);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 28px;
    box-shadow: 0 20px 60px var(--shadow);
}

.home h1 {
    margin: 0 0 12px;
    font-size: 28px;
}

.home p {
    margin: 0;
    color: var(--muted);
}

.visualization {
    background: var(--panel);
    border: 1px solid var(--border);
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 10px 40px var(--shadow);
}

.footer {
    text-align: center;
    padding: 10px 0;
    border-top: 1px solid var(--border);
    color: var(--muted);
}

.section-heading {
    font-size: 22px;
}

.panel {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 10px 30px var(--shadow);
}

.params {
    margin-bottom: 16px;
}

.params-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px 16px;
}

.field {
    display: grid;
    grid-template-columns: 1fr;
    gap: 6px;
}

.label {
    color: var(--muted);
    font-size: 12px;
}

.value {
    font-weight: 600;
}

select, input[type="number"], input[type="range"] {
    width: 100%;
}

select, input[type="number"] {
    background: #0d1424;
    border: 1px solid var(--border);
    color: var(--text);
    border-radius: 8px;
    padding: 8px 10px;
}

.hint {
    color: var(--muted);
}

.visualization-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 24px;
}

.canvas-container {
    position: relative;
    width: 100%;
    height: 500px;
    border: 1px solid var(--border);
    border-radius: 8px;
    overflow: hidden;
    background: var(--panel);
}

canvas {
    display: block;
    width: 100%;
    height: 100%;
}

.visualization-card {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 10px 30px var(--shadow);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.visualization-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 40px var(--shadow);
}

.visualization-card h3 {
    margin: 0 0 12px 0;
    color: var(--text);
    font-size: 20px;
}

.visualization-card p {
    margin: 0 0 16px 0;
    color: var(--muted);
    line-height: 1.5;
}

.card-link {
    display: inline-flex;
    align-items: center;
    color: var(--brand);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
}

.card-link:hover {
    color: var(--brand-600);
}

/* Fractal Visualization Styles */
.fractal-visualization {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 40px var(--shadow);
}

.visualization-header {
    margin-bottom: 24px;
}

.visualization-header h1 {
    margin: 0 0 12px 0;
    font-size: 28px;
    color: var(--text);
}

.visualization-header p {
    margin: 0;
    color: var(--muted);
    line-height: 1.6;
}

.controls {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    padding: 16px;
    background: #0d1424;
    border: 1px solid var(--border);
    border-radius: 12px;
    flex-wrap: wrap;
}

.control-group {
    display: flex;
    align-items: center;
    gap: 12px;
}

.control-group label {
    color: var(--muted);
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
}

.control-group input[type="range"] {
    width: 120px;
    height: 6px;
    background: var(--border);
    border-radius: 3px;
    outline: none;
    -webkit-appearance: none;
}

.control-group input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background: var(--brand);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.control-group input[type="range"]::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: var(--brand);
    border-radius: 50%;
    cursor: pointer;
    border: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.control-group span {
    color: var(--text);
    font-weight: 600;
    min-width: 30px;
    text-align: center;
}

.reset-button {
    background: var(--brand);
    color: white;
    border: none;
    padding: 10px 16px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.reset-button:hover {
    background: var(--brand-600);
}

.rendering-indicator {
    color: var(--brand);
    font-weight: 500;
    font-size: 14px;
}

.canvas-container {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
}

.info-panel {
    background: #0d1424;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 20px;
}

.info-panel h3 {
    margin: 0 0 12px 0;
    color: var(--text);
    font-size: 18px;
}

.info-panel p {
    margin: 0 0 12px 0;
    color: var(--muted);
    line-height: 1.6;
}

.info-panel p:last-child {
    margin-bottom: 0;
}

.info-panel strong {
    color: var(--text);
}

/* Riemann Sums Visualization Styles */
.riemann-visualization {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 40px var(--shadow);
}

.riemann-visualization .controls {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
    padding: 20px;
    background: #0d1424;
    border: 1px solid var(--border);
    border-radius: 12px;
}

.riemann-visualization .control-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.riemann-visualization .control-group label {
    color: var(--muted);
    font-size: 14px;
    font-weight: 500;
}

.riemann-visualization select,
.riemann-visualization input[type="number"] {
    background: #0d1424;
    border: 1px solid var(--border);
    color: var(--text);
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
}

.riemann-visualization input[type="range"] {
    width: 100%;
    height: 6px;
    background: var(--border);
    border-radius: 3px;
    outline: none;
    -webkit-appearance: none;
}

.riemann-visualization input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background: var(--brand);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.riemann-visualization input[type="range"]::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: var(--brand);
    border-radius: 50%;
    cursor: pointer;
    border: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.animate-button {
    background: var(--brand);
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    grid-column: 1 / -1;
    justify-self: start;
}

.animate-button:hover:not(:disabled) {
    background: var(--brand-600);
}

.animate-button:disabled {
    background: var(--border);
    color: var(--muted);
    cursor: not-allowed;
}

.results-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
    padding: 20px;
    background: #0d1424;
    border: 1px solid var(--border);
    border-radius: 12px;
}

.result-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.result-item strong {
    color: var(--text);
    font-size: 14px;
}

.result-item span {
    color: var(--muted);
    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
    font-size: 16px;
    font-weight: 600;
}

.riemann-visualization .info-panel ul {
    margin: 8px 0;
    padding-left: 20px;
}

.riemann-visualization .info-panel li {
    margin: 4px 0;
    color: var(--muted);
    line-height: 1.5;
}

/* Vector Field Visualization Styles */
.vector-field-visualization {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 10px 40px var(--shadow);
}

.vector-field-visualization .controls {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
    padding: 20px;
    background: #0d1424;
    border: 1px solid var(--border);
    border-radius: 12px;
}

.vector-field-visualization .control-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.vector-field-visualization .control-group label {
    color: var(--muted);
    font-size: 14px;
    font-weight: 500;
}

.vector-field-visualization select,
.vector-field-visualization input[type="range"] {
    background: #0d1424;
    border: 1px solid var(--border);
    color: var(--text);
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
}

.vector-field-visualization input[type="range"] {
    width: 100%;
    height: 6px;
    background: var(--border);
    border-radius: 3px;
    outline: none;
    -webkit-appearance: none;
}

.vector-field-visualization input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    background: var(--brand);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.vector-field-visualization input[type="range"]::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: var(--brand);
    border-radius: 50%;
    cursor: pointer;
    border: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.vector-field-visualization input[type="checkbox"] {
    margin-right: 8px;
    accent-color: var(--brand);
}

.vector-field-visualization .animate-button {
    background: var(--brand);
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    grid-column: 1 / -1;
    justify-self: start;
}

.vector-field-visualization .animate-button:hover {
    background: var(--brand-600);
}

.vector-field-visualization .animate-button.active {
    background: #ef4444;
}

.vector-field-visualization .animate-button.active:hover {
    background: #dc2626;
}

.vector-field-visualization .reset-button {
    background: var(--border);
    color: var(--text);
    border: 1px solid var(--border);
    padding: 12px 20px;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    grid-column: 1 / -1;
    justify-self: start;
    margin-top: 8px;
}

.vector-field-visualization .reset-button:hover {
    background: #374151;
}

.field-info {
    background: #0d1424;
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;
}

.field-info h3 {
    margin: 0 0 12px 0;
    color: var(--text);
    font-size: 18px;
}

.field-info p {
    margin: 0 0 12px 0;
    color: var(--muted);
    line-height: 1.6;
}

.field-info p:last-child {
    margin-bottom: 0;
}

.field-info strong {
    color: var(--text);
}

.vector-field-visualization .info-panel ul {
    margin: 8px 0;
    padding-left: 20px;
}

.vector-field-visualization .info-panel li {
    margin: 4px 0;
    color: var(--muted);
    line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+HAA+H;IAC/H,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kFAAkF;IAClF,sCAAsC;IACtC,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,8GAA8G;IAC9G,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,iCAAiC;AACjC;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,sCAAsC;AACtC;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kGAAkG;IAClG,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[":root {\n    --bg: #0f172a;\n    --panel: #0b1220;\n    --text: #e5e7eb;\n    --muted: #94a3b8;\n    --brand: #6366f1;\n    --brand-600: #4f46e5;\n    --border: #1f2937;\n    --shadow: rgba(2, 6, 23, 0.6);\n}\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\";\n    margin: 0;\n    padding: 0;\n    background-color: var(--bg);\n    color: var(--text);\n    line-height: 1.6;\n}\n\n.site-header {\n    background: linear-gradient(180deg, rgba(99,102,241,0.12), rgba(99,102,241,0) 60%);\n    border-bottom: 1px solid var(--border);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    backdrop-filter: blur(6px);\n}\n\n.header-inner {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 16px 20px;\n}\n\n.brand {\n    font-weight: 700;\n    letter-spacing: 0.2px;\n}\n\nnav .nav {\n    list-style: none;\n    display: flex;\n    gap: 16px;\n    margin: 0;\n    padding: 0;\n}\n\nnav .nav a {\n    color: var(--text);\n    text-decoration: none;\n    padding: 8px 12px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    transition: all 160ms ease;\n}\n\nnav .nav a:hover {\n    background: rgba(99, 102, 241, 0.12);\n    border-color: rgba(99, 102, 241, 0.25);\n}\n\nnav .nav a.active {\n    background: rgba(99, 102, 241, 0.2);\n    border-color: rgba(99, 102, 241, 0.35);\n    color: #fff;\n}\n\n.container {\n    max-width: 1024px;\n    width: 100%;\n    margin: 0 auto;\n    padding: 24px 20px 40px;\n}\n\n.home {\n    background: radial-gradient(1200px 600px at 50% -20%, rgba(99, 102, 241, 0.18), transparent 50%), var(--panel);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    padding: 28px;\n    box-shadow: 0 20px 60px var(--shadow);\n}\n\n.home h1 {\n    margin: 0 0 12px;\n    font-size: 28px;\n}\n\n.home p {\n    margin: 0;\n    color: var(--muted);\n}\n\n.visualization {\n    background: var(--panel);\n    border: 1px solid var(--border);\n    padding: 20px;\n    border-radius: 16px;\n    box-shadow: 0 10px 40px var(--shadow);\n}\n\n.footer {\n    text-align: center;\n    padding: 10px 0;\n    border-top: 1px solid var(--border);\n    color: var(--muted);\n}\n\n.section-heading {\n    font-size: 22px;\n}\n\n.panel {\n    background: var(--panel);\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 16px;\n    box-shadow: 0 10px 30px var(--shadow);\n}\n\n.params {\n    margin-bottom: 16px;\n}\n\n.params-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 12px 16px;\n}\n\n.field {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 6px;\n}\n\n.label {\n    color: var(--muted);\n    font-size: 12px;\n}\n\n.value {\n    font-weight: 600;\n}\n\nselect, input[type=\"number\"], input[type=\"range\"] {\n    width: 100%;\n}\n\nselect, input[type=\"number\"] {\n    background: #0d1424;\n    border: 1px solid var(--border);\n    color: var(--text);\n    border-radius: 8px;\n    padding: 8px 10px;\n}\n\n.hint {\n    color: var(--muted);\n}\n\n.visualization-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 20px;\n    margin-top: 24px;\n}\n\n.canvas-container {\n    position: relative;\n    width: 100%;\n    height: 500px;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    overflow: hidden;\n    background: var(--panel);\n}\n\ncanvas {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.visualization-card {\n    background: var(--panel);\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 10px 30px var(--shadow);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.visualization-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 15px 40px var(--shadow);\n}\n\n.visualization-card h3 {\n    margin: 0 0 12px 0;\n    color: var(--text);\n    font-size: 20px;\n}\n\n.visualization-card p {\n    margin: 0 0 16px 0;\n    color: var(--muted);\n    line-height: 1.5;\n}\n\n.card-link {\n    display: inline-flex;\n    align-items: center;\n    color: var(--brand);\n    text-decoration: none;\n    font-weight: 500;\n    transition: color 0.2s ease;\n}\n\n.card-link:hover {\n    color: var(--brand-600);\n}\n\n/* Fractal Visualization Styles */\n.fractal-visualization {\n    background: var(--panel);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 10px 40px var(--shadow);\n}\n\n.visualization-header {\n    margin-bottom: 24px;\n}\n\n.visualization-header h1 {\n    margin: 0 0 12px 0;\n    font-size: 28px;\n    color: var(--text);\n}\n\n.visualization-header p {\n    margin: 0;\n    color: var(--muted);\n    line-height: 1.6;\n}\n\n.controls {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n    padding: 16px;\n    background: #0d1424;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    flex-wrap: wrap;\n}\n\n.control-group {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.control-group label {\n    color: var(--muted);\n    font-size: 14px;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n.control-group input[type=\"range\"] {\n    width: 120px;\n    height: 6px;\n    background: var(--border);\n    border-radius: 3px;\n    outline: none;\n    -webkit-appearance: none;\n}\n\n.control-group input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 18px;\n    height: 18px;\n    background: var(--brand);\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.control-group input[type=\"range\"]::-moz-range-thumb {\n    width: 18px;\n    height: 18px;\n    background: var(--brand);\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.control-group span {\n    color: var(--text);\n    font-weight: 600;\n    min-width: 30px;\n    text-align: center;\n}\n\n.reset-button {\n    background: var(--brand);\n    color: white;\n    border: none;\n    padding: 10px 16px;\n    border-radius: 8px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.reset-button:hover {\n    background: var(--brand-600);\n}\n\n.rendering-indicator {\n    color: var(--brand);\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.canvas-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 24px;\n}\n\n.info-panel {\n    background: #0d1424;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n.info-panel h3 {\n    margin: 0 0 12px 0;\n    color: var(--text);\n    font-size: 18px;\n}\n\n.info-panel p {\n    margin: 0 0 12px 0;\n    color: var(--muted);\n    line-height: 1.6;\n}\n\n.info-panel p:last-child {\n    margin-bottom: 0;\n}\n\n.info-panel strong {\n    color: var(--text);\n}\n\n/* Riemann Sums Visualization Styles */\n.riemann-visualization {\n    background: var(--panel);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 10px 40px var(--shadow);\n}\n\n.riemann-visualization .controls {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 20px;\n    padding: 20px;\n    background: #0d1424;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n}\n\n.riemann-visualization .control-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.riemann-visualization .control-group label {\n    color: var(--muted);\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.riemann-visualization select,\n.riemann-visualization input[type=\"number\"] {\n    background: #0d1424;\n    border: 1px solid var(--border);\n    color: var(--text);\n    border-radius: 8px;\n    padding: 8px 12px;\n    font-size: 14px;\n}\n\n.riemann-visualization input[type=\"range\"] {\n    width: 100%;\n    height: 6px;\n    background: var(--border);\n    border-radius: 3px;\n    outline: none;\n    -webkit-appearance: none;\n}\n\n.riemann-visualization input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 18px;\n    height: 18px;\n    background: var(--brand);\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.riemann-visualization input[type=\"range\"]::-moz-range-thumb {\n    width: 18px;\n    height: 18px;\n    background: var(--brand);\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.animate-button {\n    background: var(--brand);\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    grid-column: 1 / -1;\n    justify-self: start;\n}\n\n.animate-button:hover:not(:disabled) {\n    background: var(--brand-600);\n}\n\n.animate-button:disabled {\n    background: var(--border);\n    color: var(--muted);\n    cursor: not-allowed;\n}\n\n.results-panel {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n    padding: 20px;\n    background: #0d1424;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n}\n\n.result-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.result-item strong {\n    color: var(--text);\n    font-size: 14px;\n}\n\n.result-item span {\n    color: var(--muted);\n    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.riemann-visualization .info-panel ul {\n    margin: 8px 0;\n    padding-left: 20px;\n}\n\n.riemann-visualization .info-panel li {\n    margin: 4px 0;\n    color: var(--muted);\n    line-height: 1.5;\n}\n\n/* Vector Field Visualization Styles */\n.vector-field-visualization {\n    background: var(--panel);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    padding: 24px;\n    box-shadow: 0 10px 40px var(--shadow);\n}\n\n.vector-field-visualization .controls {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 20px;\n    padding: 20px;\n    background: #0d1424;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n}\n\n.vector-field-visualization .control-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.vector-field-visualization .control-group label {\n    color: var(--muted);\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.vector-field-visualization select,\n.vector-field-visualization input[type=\"range\"] {\n    background: #0d1424;\n    border: 1px solid var(--border);\n    color: var(--text);\n    border-radius: 8px;\n    padding: 8px 12px;\n    font-size: 14px;\n}\n\n.vector-field-visualization input[type=\"range\"] {\n    width: 100%;\n    height: 6px;\n    background: var(--border);\n    border-radius: 3px;\n    outline: none;\n    -webkit-appearance: none;\n}\n\n.vector-field-visualization input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 18px;\n    height: 18px;\n    background: var(--brand);\n    border-radius: 50%;\n    cursor: pointer;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.vector-field-visualization input[type=\"range\"]::-moz-range-thumb {\n    width: 18px;\n    height: 18px;\n    background: var(--brand);\n    border-radius: 50%;\n    cursor: pointer;\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.vector-field-visualization input[type=\"checkbox\"] {\n    margin-right: 8px;\n    accent-color: var(--brand);\n}\n\n.vector-field-visualization .animate-button {\n    background: var(--brand);\n    color: white;\n    border: none;\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    grid-column: 1 / -1;\n    justify-self: start;\n}\n\n.vector-field-visualization .animate-button:hover {\n    background: var(--brand-600);\n}\n\n.vector-field-visualization .animate-button.active {\n    background: #ef4444;\n}\n\n.vector-field-visualization .animate-button.active:hover {\n    background: #dc2626;\n}\n\n.vector-field-visualization .reset-button {\n    background: var(--border);\n    color: var(--text);\n    border: 1px solid var(--border);\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    grid-column: 1 / -1;\n    justify-self: start;\n    margin-top: 8px;\n}\n\n.vector-field-visualization .reset-button:hover {\n    background: #374151;\n}\n\n.field-info {\n    background: #0d1424;\n    border: 1px solid var(--border);\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 24px;\n}\n\n.field-info h3 {\n    margin: 0 0 12px 0;\n    color: var(--text);\n    font-size: 18px;\n}\n\n.field-info p {\n    margin: 0 0 12px 0;\n    color: var(--muted);\n    line-height: 1.6;\n}\n\n.field-info p:last-child {\n    margin-bottom: 0;\n}\n\n.field-info strong {\n    color: var(--text);\n}\n\n.vector-field-visualization .info-panel ul {\n    margin: 8px 0;\n    padding-left: 20px;\n}\n\n.vector-field-visualization .info-panel li {\n    margin: 4px 0;\n    color: var(--muted);\n    line-height: 1.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
